import { render, staticRenderFns } from "./ExternalAccessSelectSeatPage.vue?vue&type=template&id=61647d4a&"
import script from "./ExternalAccessSelectSeatPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalAccessSelectSeatPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports